export const initialState = {
    filter: {
        laboratoryName: null,
        status: null,
        regionalId: null,
    },
    isFilter: false,
  };
  
  const filterLaboratoryReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_FILTER_LABORATORY":
        return {
          ...state,
          filter: action.filter,
          isFilter: action.isFilter,
        };
      default:
        return state;
    }
  };
  
  export default filterLaboratoryReducer;
  